import React, { memo } from 'react';
import { Icon, Text } from '@cashfree-intl/coherent';

// Types
import { BackButtonProps } from './types';

// Styled
import { StyledBackButton } from './styled';

const BackButton = (props: BackButtonProps) => {
  return (
    <StyledBackButton alignItems="center" {...props}>
      <Icon name="chevron-left" height={16} width={16} />
      <Text variant="b14" color="primary" className="ml-1">
        Back
      </Text>
    </StyledBackButton>
  );
};

export default memo(BackButton);
